import React from 'react';

import {ContactLink} from "./ContactLink";

export const ContactFieldViewer = (props) => {
    const { Data, Value } = props;
    return <ContactLink contact={Data} contactId={Value} />;
};
